import script from "./WorkWall.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkWall.vue?vue&type=script&lang=ts&setup=true"

import "./WorkWall.vue?vue&type=style&index=0&id=4d80b122&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d80b122"]])

export default __exports__